import { TextSource, FontData } from '../../../../types/text';

export const DEFAULT_EDITOR_DATA = ['', [], TextSource.INITIAL] as FontData;
